import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';
import { callLoginApi, LoginResData, TermsRedirectResData } from 'requests/RequestLogin';
import { ApiError } from 'requests/RequestBase';
import { User } from 'requests/RequestUser';
import { HttpStatus } from 'consts/HttpStatus';
import { findErrorMessageByApiError } from 'consts/ApiErrorCode';
import { ReactError } from 'consts/ReactError';

export type LoginUserData = {
	actionError: string;
	isErrorRedirect: boolean;
	isRedirect: boolean;
	isFirstAgreement: boolean;
	gidpk: string;
	gid: string;
	lastname: string;
	firstname: string;
	isChild: boolean;
	mailaddress_1: string;
};

export const initialLoginUserData: LoginUserData = {
	actionError: '',
	isErrorRedirect: false,
	isRedirect: false,
	isFirstAgreement: true,
	gidpk: '',
	gid: '',
	lastname: '',
	firstname: '',
	isChild: false,
	mailaddress_1: '',
};

//////////////////////////////////////////////////
// LoginAction
//////////////////////////////////////////////////
// Action
class LoginAction extends ActionBase {
	loginUserData1: LoginUserData;
}
// Action name
const LoginActionName = LoginAction.toString();

// Action generator
export const loginGenerator = async (dispatch: React.Dispatch<ActionBase>, gakkenId: string, password: string) => {
	const loginUserData = { ...initialLoginUserData };

	const result = await callLoginApi({ gid: gakkenId, pw: password });
	if (result.status === HttpStatus.OK) {
		const successData = result.data as LoginResData;
		loginUserData.gidpk = successData.gid_data.gidpk;
		loginUserData.gid = gakkenId;
		loginUserData.lastname = successData.gid_data.lastname;
		loginUserData.firstname = successData.gid_data.firstname;
		loginUserData.isChild = successData.gid_data.member_flg === 1;
		loginUserData.mailaddress_1 = successData.gid_data.mailaddress_1;
		loginUserData.actionError = '';
	} else if (result.status === HttpStatus.INTERNAL_SERVER_ERROR) {
		loginUserData.isErrorRedirect = true;
	} else if (result.status === HttpStatus.REDIRECT) {
		const termsData = result.data as TermsRedirectResData;
		loginUserData.isRedirect = true;
		loginUserData.isFirstAgreement = termsData.isFirstAgreement;
	} else if (result.status === HttpStatus.GATEWAY_TIMEOUT) {
		loginUserData.actionError = ReactError.E9998;
	} else {
		const errorData = result.data as ApiError;
		loginUserData.actionError = findErrorMessageByApiError(errorData);
	}

	const action = {
		action: LoginActionName,
		loginUserData1: loginUserData,
	} as LoginAction;

	dispatch(action);
};

// Reducer
const loginReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as LoginAction;
	const newState: Store = copyObject(state);
	newState.loginUserData = thisAction.loginUserData1;
	return newState;
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	loginUserData2: LoginUserData;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>, gidData: User) => {
	const loginUserData = { ...initialLoginUserData };
	loginUserData.gidpk = gidData.gidpk;
	loginUserData.gid = gidData.gid;
	loginUserData.lastname = gidData.lastname;
	loginUserData.firstname = gidData.firstname;
	loginUserData.isChild = gidData.member_flg === 1;
	loginUserData.mailaddress_1 = gidData.mailaddress_1;
	loginUserData.actionError = '';

	const action = {
		action: SaveActionName,
		loginUserData2: loginUserData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.loginUserData = thisAction.loginUserData2;
	return newState;
};

//////////////////////////////////////////////////
// ClearAction
//////////////////////////////////////////////////
// Action
class ClearAction extends ActionBase {}
// Action name
const ClearActionName = ClearAction.toString();

// Action generator
export const clearGenerator = async (dispatch: React.Dispatch<ActionBase>) => {
	const action = {
		action: ClearActionName,
	} as ClearAction;

	dispatch(action);
};

// Reducer
const clearReducer = (state: Store, _action: ActionBase): Store => {
	const newState: Store = copyObject(state);
	newState.loginUserData = copyObject(initialLoginUserData);
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const LoginUserReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case LoginActionName:
			return loginReducer(state, action);
		case SaveActionName:
			return saveReducer(state, action);
		case ClearActionName:
			return clearReducer(state, action);
	}
	return null;
};
